import React, {useMemo} from 'react';
import {useConfig} from 'utils/ConfigProvider';
import {ThirdPartySurveyQuestionRenderer} from "./renderer";
import classnames from "classnames";
import style from "./style.module.scss";

export function ThirdPartySurvey(props) {
  const {
    overlay,
    showing,
  } = props;
  const {creativeCard} = overlay
  const {thirdPartySurveyEngagement} = creativeCard;
  const {environment} = useConfig();

  const isCreativeStudioPreviewMode = useMemo(() => {
    return environment.isCreativeStudioPreviewMode instanceof Function ? environment.isCreativeStudioPreviewMode() : false;
  }, [environment]);

  const memoizedQuestions = useMemo(() => {

    return thirdPartySurveyEngagement.questions.map((question, index) => {
      return <ThirdPartySurveyQuestionRenderer
        question={question}
        key={index}
      />
    })
  }, [thirdPartySurveyEngagement.questions])

  if (!showing) {
    return <React.Fragment/>;
  }

  return <div
    className={classnames(style.container, isCreativeStudioPreviewMode ? style.pointerEventsNone : null)}
  >

    {memoizedQuestions}
  </div>
}
